export default __webpack_public_path__ + "static/media/174.426594be.png";